import { useEffect } from 'react';
import useAuthStore from '../stores/authStore';

export function useAuth() {
  const { user, loading, fetchUser, clearUser } = useAuthStore();

  useEffect(() => {
    fetchUser();
    const handler = () => clearUser();
    window.addEventListener('auth:unauthorized', handler);
    return () => window.removeEventListener('auth:unauthorized', handler);
  }, []);

  return { user, loading };
}
